import angular from "angular";
import LibraryCostsPageComponent from "./library-costs-page/library-costs-page.component";
import CostFolderModalComponent from "./cost-folder-modal/cost-folder-modal";
import ImportCostsCsvModalComponent from "./import-costs-csv-modal/import-costs-csv-modal";
import CostModalComponent from "./cost-modal/cost-modal";
import MoveCostModalComponent from "./move-cost-modal/move-cost-modal";
import SelectCostModalComponent from "./select-cost-modal/select-cost-modal-controller";

const LibraryCostsModule = angular
  .module("modules.libraryCosts", [])
  .component("costFolderModal", CostFolderModalComponent)
  .component("importCostsCsvModal", ImportCostsCsvModalComponent)
  .component("costModal", CostModalComponent)
  .component("libraryCostsPage", LibraryCostsPageComponent)
  .component("moveCostModal", MoveCostModalComponent)
  .component("selectCostModal", SelectCostModalComponent);

export default LibraryCostsModule;
